import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { api_url_v1 } from '../utils/config';


let token = null;

try {
  token = window.localStorage.getItem('adminToken');
} catch {
  token = null;
}
// Get all products
export const getProducts = createAsyncThunk(
  'products/getProducts',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${api_url_v1}/getProducts`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        params: {
            _cb: new Date().getTime()  // anyone who inherits this....make sure not to touch this..or just let the backend dev know cos the current dev doesnt know how to deal with this..he thinks caching issues are always on the FE
        }
      });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch products');
    }
  }
);

// Get products by category
export const getProductsByCategory = createAsyncThunk(
  'products/getProductsByCategory',
  async (categoryId, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${api_url_v1}/getProducts?category=${categoryId}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        }
      });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch products by category');
    }
  }
);

// Add new product
export const addProduct = createAsyncThunk(
  'products/addProduct',
  async (productData, { rejectWithValue }) => {
    console.log('token',token)
    try {
      const response = await axios.post(`${api_url_v1}/addProduct`, productData, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        }
      });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to add product');
    }
  }
);

// Edit product
export const editProduct = createAsyncThunk(
  'products/editProduct',
  async ({ productToken, productData }, { rejectWithValue }) => {
    const data = {...productData,productToken}
    try {
      const response = await axios.put(`${api_url_v1}/editProduct`, productData, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({data}),

      });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to edit product');
    }
  }
);

// Delete product
export const deleteProduct = createAsyncThunk(
  'products/deleteProduct',
  async (productToken, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`${api_url_v1}/deleteProduct`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        data: {
            productToken: productToken
          }
      });
      return productToken;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to delete product');
    }
  }
);

// Initial state
const initialState = {
  products: [],
  filteredProducts: [],
  selectedProduct: null,
  loading: false,
  error: null,
  success: false,
  message: ''
};

// Create slice
const productSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccess: (state) => {
      state.success = false;
      state.message = '';
    },
    setSelectedProduct: (state, action) => {
      state.selectedProduct = action.payload;
    },
    filterProducts: (state, action) => {
      const { searchTerm, status, category } = action.payload;
      
      state.filteredProducts = state.products?.filter(product => {
        const productName = product.productName || product.name || '';
        const productCategory = product.category?.category || product.category || '';
        
        const matchesSearch = searchTerm
          ? productName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            productCategory.toLowerCase().includes(searchTerm.toLowerCase())
          : true;
        
        const matchesStatus = status && status !== 'all'
          ? product.status === status
          : true;
        
        const matchesCategory = category && category !== 'all'
          ? productCategory === category
          : true;
        
        return matchesSearch && matchesStatus && matchesCategory;
      });
    },
    resetFilteredProducts: (state) => {
      state.filteredProducts = state.products;
    }
  },
  extraReducers: (builder) => {
    builder
      // Get all products
      .addCase(getProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload;
        state.filteredProducts = action.payload;
        state.error = null;
      })
      .addCase(getProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      // Get products by category
      .addCase(getProductsByCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProductsByCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.filteredProducts = action.payload;
        state.error = null;
      })
      .addCase(getProductsByCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      // Add product
      .addCase(addProduct.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(addProduct.fulfilled, (state, action) => {
        state.loading = false;
        state.products.push(action.payload);
        state.filteredProducts.push(action.payload);
        state.success = true;
        state.message = 'Product added successfully';
        state.error = null;
      })
      .addCase(addProduct.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      
      // Edit product
      .addCase(editProduct.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(editProduct.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.products.findIndex(p => p.id === action.payload.id);
        if (index !== -1) {
          state.products[index] = action.payload;
        }
        const filteredIndex = state.filteredProducts.findIndex(p => p.id === action.payload.id);
        if (filteredIndex !== -1) {
          state.filteredProducts[filteredIndex] = action.payload;
        }
        state.success = true;
        state.message = 'Product updated successfully';
        state.error = null;
      })
      .addCase(editProduct.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      
      // Delete product
      .addCase(deleteProduct.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(deleteProduct.fulfilled, (state, action) => {
        state.loading = false;
        state.products = state.products.filter(p => p.productToken !== action.payload);
        state.filteredProducts = state.filteredProducts.filter(p => p.productToken !== action.payload);
        state.success = true;
        state.message = 'Product deleted successfully';
        state.error = null;
      })
      .addCase(deleteProduct.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  }
});

export const {
  clearError,
  clearSuccess,
  setSelectedProduct,
  filterProducts,
  resetFilteredProducts
} = productSlice.actions;

export default productSlice.reducer;